import {useEffect, useState} from "react";
import {apiClient} from "../api/apiClient";
import {Category} from "../interfaces/interfaces";

export const useCategories = ()=> {
    const [categories, setCategories] = useState<Category[]>([]);

    useEffect(() => {
        apiClient.get('/categories')
            .then((r: any) => setCategories(r.data))
            .catch(console.error);
    }, []);
    return categories;
}
